export default __webpack_public_path__ + "static/media/Cardview-Default.773bd320.svg";